// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-details__carousel__dot--active,.product-details__carousel__dot{width:6px;height:6px;padding:0;border:0;border-radius:50%;margin:0 4px;cursor:pointer}.product-details__carousel__dot{background:#636f7e}.product-details__carousel__dot--active{background:#132226}", ""]);
// Exports
module.exports = exports;
